import { c as _c } from "react/compiler-runtime";
import useScreenWidth from '@/contexts/appContext/hooks/useScreenWidth';
import { useEffect, useState } from 'react';
import { CONFIG_BREAKPOINTS, INITIAL_TAILWIND_CONTEXT, TAILWIND_CONFIG } from './tailwind.const';
import TailwindContext from './tailwind.context';
export const TailwindProvider = (t0) => {
    const $ = _c(12);
    const { children } = t0;
    const width = useScreenWidth();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = Object.fromEntries(Object.entries(CONFIG_BREAKPOINTS).map(_temp));
        $[0] = t1;
    }
    else {
        t1 = $[0];
    }
    const [activeBreakpoints, setActiveBreakpoints] = useState(t1);
    let t2;
    let t3;
    if ($[1] !== width) {
        t2 = () => {
            const newBreakpoints = {};
            Object.entries(CONFIG_BREAKPOINTS).forEach((t4) => {
                const [key_0, value] = t4;
                newBreakpoints[key_0] = width >= value;
            });
            setActiveBreakpoints(newBreakpoints);
        };
        t3 = [width];
        $[1] = width;
        $[2] = t2;
        $[3] = t3;
    }
    else {
        t2 = $[2];
        t3 = $[3];
    }
    useEffect(t2, t3);
    const [isDarkTheme, setIsDarkTheme] = useState(INITIAL_TAILWIND_CONTEXT.isDarkTheme);
    let t4;
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = () => {
            setIsDarkTheme(window.matchMedia("(prefers-color-scheme: dark)").matches);
        };
        t5 = [];
        $[4] = t4;
        $[5] = t5;
    }
    else {
        t4 = $[4];
        t5 = $[5];
    }
    useEffect(t4, t5);
    let t6;
    if ($[6] !== activeBreakpoints || $[7] !== isDarkTheme) {
        t6 = { config: TAILWIND_CONFIG, activeBreakpoints, numericBreakpoints: CONFIG_BREAKPOINTS, isDarkTheme };
        $[6] = activeBreakpoints;
        $[7] = isDarkTheme;
        $[8] = t6;
    }
    else {
        t6 = $[8];
    }
    const contextValue = t6;
    let t7;
    if ($[9] !== children || $[10] !== contextValue) {
        t7 = <TailwindContext value={contextValue}>{children}</TailwindContext>;
        $[9] = children;
        $[10] = contextValue;
        $[11] = t7;
    }
    else {
        t7 = $[11];
    }
    return t7;
};
function _temp(t0) { const [key] = t0; return [key, true]; }
